Select2RemoteMixin =
  template: "<select :name='name' :id='id'></select>"
  props: ['name', 'source', 'textName', 'valueName', 'url', 'passedValueName', 'id', 'tags']
  mounted: ->
    if @source
      option = "<option value='#{@selectedValue}' selected>#{@selectedName}</option>"
      @input.append(option).trigger("change")
    vm = this
    @input.select2(@selectOptions()).on('change', -> vm.updateValue(this))
  computed:
    input: ->
      $(@$el)
    selectedValue: ->
      @source[@initialValueName]
    selectedName: ->
      @source[@textName]
    initialValueName: ->
      @passedValueName || @valueName
  methods:
    updateValue: (select)->
      if select.length > 0
        @$emit('input', $(select).val())
    selectOptions: ->
      opts =
        allowClear: true
        dropdownAutoWidth: true
        width: '100%'
        theme: 'bootstrap'
        tags: @tags || false
        placeholder: @placeholder || ' '
        ajax: @ajax()
    ajax: ->
      url: @url
      dataType: 'json'
      data: (query, page) ->
        { q: query }
      processResults: (resources, page) =>
        textName  = @textName
        valueName = @valueName || 'id'
        for resource in resources
          resource.id   = Helper.escapeString(resource[valueName])
          resource.text = Helper.escapeString(resource[textName])
        { results: resources }

export default Select2RemoteMixin